/**
 * DemoBanner.jsx (iter226) — Persistent banner shown at the top of every
 * Layout page when the tenant is a Competition Demo tenant. Reminds the
 * judge they are in the demo and offers quick return + reset shortcuts.
 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Trophy, ArrowClockwise, House } from '@phosphor-icons/react';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';
import { resetCompetitionDemo } from '../lib/api';

export default function DemoBanner() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  if (!user?.company?.is_demo) return null;

  const reset = async () => {
    if (!window.confirm('Reset the Competition Demo to its original state?')) return;
    setBusy(true);
    try {
      await resetCompetitionDemo();
      toast.success('Demo reset');
      window.location.reload();
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Reset failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bg-emerald-500 text-neutral-950 text-xs font-black uppercase tracking-widest px-4 py-2 flex items-center justify-between gap-3 border-b border-emerald-700"
         data-testid="demo-banner">
      <div className="flex items-center gap-2">
        <Trophy size={14} weight="fill" />
        Competition Demo · Isolated tenant · Nothing here touches production
      </div>
      <div className="flex items-center gap-1">
        <Button size="sm" variant="ghost"
          onClick={() => navigate('/competition-demo/dashboard')}
          className="h-6 rounded-none text-neutral-950 hover:bg-emerald-600 text-[10px] uppercase tracking-widest font-black"
          data-testid="demo-banner-dashboard">
          <House size={12} className="mr-1" /> Dashboard
        </Button>
        <Button size="sm" variant="ghost"
          onClick={reset} disabled={busy}
          className="h-6 rounded-none text-neutral-950 hover:bg-emerald-600 text-[10px] uppercase tracking-widest font-black"
          data-testid="demo-banner-reset">
          <ArrowClockwise size={12} className="mr-1" /> {busy ? 'Resetting…' : 'Reset'}
        </Button>
      </div>
    </div>
  );
}
